import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Collapse from "@material-ui/core/Collapse";
// core components
import SidebarLinks from "./SideBarLink";
import DesktopHeader from "../Header/DesktopHeader";
import brandTheme from "brandTheme/Theme";
import CustomeTextField from "../CustomeTextField";
import { InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import PersonalLoanSidebarLinks from "./PersonalLoanSidebarLinks";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { parseAndSetFlag } from "utils/Utils";
import { masterNames } from "assets/properties/properties";
import { useSelector } from "react-redux";
import CollapsiblePanel from "./CollapsiblePanel";
import CollapsiblePanelChild from "./CollapsiblePanelChild";
import Discrepancy from "../../../assets/img/discrepancy.png";
const useStyles = makeStyles(({ theme }) => ({
  itemIcon: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.black,
  },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "16px",
    fontSize: "14px",
    color: brandTheme.black,
  },
  sidebarWrapper: {
    position: "relative",
    width: "260px",
    height: "600px",
    overflowY: "scroll",
      '@media only screen and (max-width: 900px)': {
        height:'100%',
    },
  },
  dashboardMenu: {
    backgroundColor: brandTheme.sideBarColor,
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
    marginBottom: "8px",
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  dashboardMenu1: {
    backgroundColor: brandTheme.sideBarColor,
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
    marginBottom: "8px",
    paddingLeft: "42px",
    width: "auto",
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  item: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,

    "&:focus,&:visited,&": {
      color: brandTheme.black,
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  item2: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,
    paddingLeft: "56px",
    "&:focus,&:visited,&": {
      color: brandTheme.black,
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  item1: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,
    // paddingLeft: "26px",
    "&:focus,&:visited,&": {
      color: brandTheme.black,
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  activeClass: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    paddingLeft: "56px",
    backgroundColor: brandTheme.sideBarHoverColor,
  },
  children: {
    "& $activeClass": {
      paddingLeft: 26,
    },
    "& $item": {
      paddingLeft: 26,
    },
  },
  children1: {
    "& $activeClass": {
      paddingLeft: 54,
    },
    "& $item": {
      paddingLeft: 54,
    },
  },
}));

const SideBar = ({ handleDrawerToggle, open, outletData, userDetailsData }) => {
  const [itemState, setItemState] = useState({});
  const [masterOpen, setMasterOpen] = useState(true);
  const [activeLink, setActiveLink] = useState("/coreservice/core-dashboard");
  const [searchQuery, setSearchQuery] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [childrenOpen, setChildrenOpen] = useState(true);
  const classes = useStyles();
  const [rawData, setRawData] = useState([]);
  const filteredSidebarTabs = filterTabsBySearch(rawData?.[0]?.children || [], searchQuery);

  function filterTabsBySearch(tabs, query) {
  const loweredQuery = query.toLowerCase();

  return tabs
    .map(tab => {
      // Recursively filter children
      const filteredChildren = tab.children
        ? filterTabsBySearch(tab.children, query)
        : [];

      // Check if current tab matches the query
      const isMatch = tab.name?.toLowerCase().includes(loweredQuery);

      // Include the item if it matches or any of its children do
      if (isMatch || filteredChildren.length > 0) {
        return {
          ...tab,
          children: filteredChildren.length > 0 ? filteredChildren : undefined,
        };
      }

      return null;
    })
    .filter(Boolean); // remove nulls
}
  const personalLoanSideBar = parseAndSetFlag(outletData?.enablePersonalLoanFlag);
  const renderedSideBar = rawData;

  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const designationOrRoleBased = parseAndSetFlag(
      outletData?.showTabsAsPerTheDesignationFlag
    );
    if (designationOrRoleBased || !designationOrRoleBased) {
      await getUserDetails(designationOrRoleBased,outletData?.roleOrDesignationForAccessRestrictionTab);
    }
  };
  function filterSidebarItems(items,enabledCodes) {
  return items
    ?.map(item => {
      const isAllowed = enabledCodes?.has(item.code);

      // Recursively check children
      const filteredChildren = item.children ? filterSidebarItems(item.children,enabledCodes) : [];

      // Keep this item if it's allowed OR has allowed children
      if (isAllowed || filteredChildren.length > 0) {
        return {
          ...item,
          children: filteredChildren.length > 0 ? filteredChildren : undefined,
        };
      }

      return null; // Don't include this item
    })
    .filter(Boolean); // Remove nulls
}

  const getUserDetails = async (designationOrRoleBased, roleDesignationBasedList) => {
    const searchParam = designationOrRoleBased
      ? userDetailsData?.designation
      : userDetailsData?.role;
    GetData(searchParam, designationOrRoleBased, userDetailsData, roleDesignationBasedList);
  };
  const GetData = async (searchParam, designationOrRoleBased, userDetails, roleDesignationBasedList) => {
  setCallInProgress(true);

  const query = designationOrRoleBased
    ? `designation=${searchParam}`
    : `role=${searchParam}`;

  const result = await apiHandler({
    url: endpoint.UI_RESTRICTION_FIND + query,
    authToken: authToken,
  });

  setCallInProgress(false);

  const hasSpecialRole = roleDesignationBasedList?.includes(userDetails?.role);
  const hasSpecialDesignation = roleDesignationBasedList?.includes(userDetails?.designation);
  const renderSidebarLinks = personalLoanSideBar ? PersonalLoanSidebarLinks : SidebarLinks;
  // Start with a clean deep copy of SidebarLinks[0]
  const baseChildren = renderSidebarLinks?.[0]?.children || [];
  let finalRenderList = [
    {
      ...renderSidebarLinks?.[0],
      children: [...baseChildren],
    },
  ];

  if (result?.data?.error_code || result?.data?.user_description) {
    if (hasSpecialRole || hasSpecialDesignation) {
      finalRenderList[0].children.push({
        name: masterNames?.accessRestriction,
        code: "ACCESSRESTRICTION",
        url: "/coreservice/AccessRestriction",
        icon: Discrepancy,
      });
    }
    setRawData(finalRenderList);
    return;
  }

  // Normal case: parse and filter sidebar
  const coreListData = JSON.parse(result?.data?.restrictions);
  const enabledCodes = new Set(
    coreListData?.core?.filter(item => !item.disabled).map(item => item.code)
  );

  finalRenderList[0].children = filterSidebarItems(baseChildren, enabledCodes);

  if (hasSpecialRole || hasSpecialDesignation) {
    finalRenderList[0].children.push({
      name: masterNames?.accessRestriction,
      code: "ACCESSRESTRICTION",
      url: "/coreservice/AccessRestriction",
      icon: Discrepancy,
    });
  }

  console.log(finalRenderList, enabledCodes, "finalRenderList");
  setRawData(finalRenderList);
};
  const renderedFilterSideBar = filteredSidebarTabs;
  const handleActiveLink = (link) => {
    setActiveLink(link);
  };
  const grandChildHandle = (children) => {
    return children?.map((subOption) => {
      if (!subOption?.children) {
        return (
          <NavLink
            to={subOption.url}
            className={
              subOption.url === activeLink ? classes.activeClass : classes.item2
            }
            activeClassName="active"
            key={subOption.name}
            onClick={() => handleActiveLink(subOption.url)}
          >
            <ListItem button>
              {typeof subOption.icon === "string" ? (
                <img
                  src={subOption.icon}
                  alt={""}
                  className={classNames(classes.itemIcon)}
                ></img>
              ) : (
                <subOption.icon className={classNames(classes.itemIcon)} />
              )}
              <ListItemText
                primary={subOption.name}
                className={classNames(classes.itemText)}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        );
      }
      return (
        <div key={subOption.name}>
          <CollapsiblePanelChild
            collapse={childrenOpen}
            subOption={subOption}
            secondHandle={grandChildHandle}
          />
        </div>
      );
    });
  };
  const secondHandle = (children) => {
    return (
      <div key={children}>
        {children?.map((subOption) => {
          //    if((subOption?.name === masterNames?.goldRateMaster && parseAndSetFlag(featureFlag?.skipGoldRateFlag)) ||
          //    (subOption?.name === masterNames?.ornamentMaster  && parseAndSetFlag(featureFlag?.skipOrnamnentFlag)) ||
          //    (subOption?.name === masterNames?.standardDeductionMaster && parseAndSetFlag(featureFlag?.skipStandardDeductionFlag)) ||
          //    (subOption?.name === masterNames?.noticeBoardMaster && parseAndSetFlag(featureFlag?.skipNoticeBoardFlag)) ||
          //    (subOption?.name === masterNames?.registerMaster && parseAndSetFlag(featureFlag?.skipRegisterFlag)) ||
          //    (subOption?.name === masterNames?.packetInventoryMaster && parseAndSetFlag(featureFlag?.skipPacketInventoryFlag)) ||
          //    (subOption?.name === masterNames?.lenderMaster && parseAndSetFlag(featureFlag?.skipLenderFlag)) ||
          //    (subOption?.name === masterNames?.relationshipMaster && parseAndSetFlag(featureFlag?.skipRelationshipFlag)) ||
          //    (subOption?.name === masterNames?.negativeProfileMaster  && parseAndSetFlag(featureFlag?.skipNegativeProfileFlag)) ||
          //    (subOption?.name === masterNames?.discrepancyMaster && parseAndSetFlag(featureFlag?.skipDiscrepancyFlag)) ||
          //    (subOption?.name === masterNames?.collateralValuationMaster  && parseAndSetFlag(featureFlag?.skipCollateralValuationFlag)) ||
          //    (subOption?.name === masterNames?.riskCategoryMaster  && parseAndSetFlag(featureFlag?.skipRiskCategoryFlag)) ||
          //    (subOption?.name === masterNames?.insuranceMaster && !parseAndSetFlag(featureFlag?.enableInsuranceFlowFlag)) ||
          //    (subOption?.name === masterNames?.thirdPartyMaster && !parseAndSetFlag(featureFlag?.showThirdPartyFlag)) ||
          //    (subOption?.name === masterNames?.holidayMaster && !parseAndSetFlag(featureFlag?.showHolidayMasterFlag)) ||
          //    (subOption?.name === masterNames?.glHeadMaster && !parseAndSetFlag(featureFlag?.showGlHeadMaster)) ||
          //    (subOption?.name === masterNames?.whiteListIpMaster && !parseAndSetFlag(featureFlag?.showWhiteListIpMaster)) ||
          //    (designation === "HR" && (subOption?.name !== masterNames?.inviteUserMaster && subOption?.name !== masterNames?.masterList) && parseAndSetFlag(featureFlag?.showTabsAsPerTheDesignationFlag))
          //  )
          //  return null;
          if (!subOption?.children) {
            return (
              <NavLink
                to={subOption.url}
                className={
                  subOption.url === activeLink
                    ? classes.activeClass1
                    : classes.item1
                }
                activeClassName="active"
                key={subOption.name}
                onClick={() => handleActiveLink(subOption.url)}
              >
                <ListItem button>
                  {typeof subOption.icon === "string" ? (
                    <img
                      src={subOption.icon}
                      alt={""}
                      className={classNames(classes.itemIcon)}
                    ></img>
                  ) : (
                    <subOption.icon className={classNames(classes.itemIcon)} />
                  )}
                  <ListItemText
                    primary={subOption.name}
                    className={classNames(classes.itemText)}
                    disableTypography={true}
                  />
                </ListItem>
              </NavLink>
            );
          }
          return (
            <div key={subOption.name}>
              <CollapsiblePanelChild
                collapse={childrenOpen}
                subOption={subOption}
                secondHandle={grandChildHandle}
                filteredSidebarTabs={filteredSidebarTabs}
              />
            </div>
          );
        })}
      </div>
    );
  };
  const handler = (children) => {
    return children.map((subOption, index) => {
      //   if((subOption?.name === masterNames?.goldRateMaster && parseAndSetFlag(featureFlag?.skipGoldRateFlag)) ||
      //   (subOption?.name === masterNames?.ornamentMaster  && parseAndSetFlag(featureFlag?.skipOrnamnentFlag)) ||
      //   (subOption?.name === masterNames?.standardDeductionMaster && parseAndSetFlag(featureFlag?.skipStandardDeductionFlag)) ||
      //   (subOption?.name === masterNames?.noticeBoardMaster && parseAndSetFlag(featureFlag?.skipNoticeBoardFlag)) ||
      //   (subOption?.name === masterNames?.registerMaster && parseAndSetFlag(featureFlag?.skipRegisterFlag)) ||
      //   (subOption?.name === masterNames?.packetInventoryMaster && parseAndSetFlag(featureFlag?.skipPacketInventoryFlag)) ||
      //   (subOption?.name === masterNames?.lenderMaster && parseAndSetFlag(featureFlag?.skipLenderFlag)) ||
      //   (subOption?.name === masterNames?.relationshipMaster && parseAndSetFlag(featureFlag?.skipRelationshipFlag)) ||
      //   (subOption?.name === masterNames?.negativeProfileMaster  && parseAndSetFlag(featureFlag?.skipNegativeProfileFlag)) ||
      //   (subOption?.name === masterNames?.discrepancyMaster && parseAndSetFlag(featureFlag?.skipDiscrepancyFlag)) ||
      //   (subOption?.name === masterNames?.collateralValuationMaster  && parseAndSetFlag(featureFlag?.skipCollateralValuationFlag)) ||
      //   (subOption?.name === masterNames?.riskCategoryMaster  && parseAndSetFlag(featureFlag?.skipRiskCategoryFlag)) ||
      //   (designation === "HR" && (subOption?.name !== masterNames?.inviteUserMaster && subOption?.name !== masterNames?.masterList) && parseAndSetFlag(featureFlag?.showTabsAsPerTheDesignationFlag))
      // )
      //   return null;
      if (!subOption?.children) {
        return (
          <NavLink
            to={subOption?.url}
            className={
              subOption?.url === activeLink ? classes.activeClass : classes.item
            }
            activeclassname="active"
            key={subOption?.name}
          >
            <ListItem button>
              {typeof subOption?.icon === "string" ? (
                <img
                  src={subOption?.icon}
                  alt={""}
                  className={classNames(classes.itemIcon)}
                ></img>
              ) : (
                <subOption.icon className={classNames(classes.itemIcon)} />
              )}
              <ListItemText
                primary={subOption?.name}
                className={classNames(classes.itemText)}
                disableTypography={true}
                onClick={() => [
                  setActiveLink(subOption?.url),
                  handleDrawerToggle,
                ]}
              />
            </ListItem>
          </NavLink>
        );
      }
      return (
        <div key={index}>
          <CollapsiblePanel
            collapse={!masterOpen}
            subOption={subOption}
            secondHandle={secondHandle}
          />
        </div>
      );
    });
  };
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  return (
    <div>
      <TextField
        label="search"
        variant="outlined"
        style={{
          width: "95%",
          marginTop: "3%",
          marginLeft: "2%",
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
          style: { width: "100%" },
        }}
        onChange={handleSearchInputChange}
        size="small"
      />
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className={classes.sidebarWrapper}>
            {<DesktopHeader />}
            {searchQuery
              ? handler(renderedFilterSideBar)
              : handler(renderedSideBar)}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.sidebarWrapper}>
          {searchQuery
            ? handler(renderedFilterSideBar)
            : handler(renderedSideBar)}
        </div>
      </Hidden>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

SideBar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  open: PropTypes.bool,
};

export default SideBar;
